/**
 * Aurora Theme — Quick view modal.
 * Fetches product data via the Storefront's product .js endpoint and
 * builds the modal client-side from the <template id="QuickViewTemplate">
 * (snippets/quick-view.liquid), then adds to cart via the Cart AJAX API.
 */
(function () {
  'use strict';

  var root = document.getElementById('quick-view-root');
  var template = document.getElementById('QuickViewTemplate');
  if (!root || !template) return;

  var currentProduct = null;
  var selectedOptions = [];

  function formatMoney(cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || undefined, {
      style: 'currency',
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD'
    });
  }

  function findVariant(options) {
    return currentProduct.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === options[i]; });
    });
  }

  function open() {
    root.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function close() {
    root.hidden = true;
    root.innerHTML = '';
    document.body.style.overflow = '';
    currentProduct = null;
  }

  function render(product) {
    currentProduct = product;
    var initialVariant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    selectedOptions = initialVariant.options.slice();

    var fragment = template.content.cloneNode(true);
    var dialog = fragment.querySelector('.quick-view__dialog');

    var media = dialog.querySelector('[data-quick-view-media]');
    (product.images.length ? product.images.slice(0, 1) : []).forEach(function (src) {
      var img = document.createElement('img');
      img.src = src.replace(/(\.[a-z]+)(\?|$)/i, '_800x$1$2');
      img.alt = product.title;
      media.appendChild(img);
    });
    if (!product.images.length) {
      media.innerHTML = '<div class="main-product__gallery-slide is-active"></div>';
    }

    dialog.querySelector('[data-quick-view-vendor]').textContent = product.vendor || '';
    dialog.querySelector('[data-quick-view-title]').textContent = product.title;
    dialog.querySelector('[data-quick-view-full-link]').setAttribute('href', product.url);

    var variantsWrap = dialog.querySelector('[data-quick-view-variants]');
    if (!product.options_with_values || product.variants.length <= 1) {
      variantsWrap.remove();
    } else {
      product.options_with_values.forEach(function (option, position) {
        var group = document.createElement('div');
        group.className = 'main-product__option';
        var label = document.createElement('label');
        label.textContent = option.name + ': ';
        var selectedSpan = document.createElement('span');
        selectedSpan.textContent = selectedOptions[position];
        label.appendChild(selectedSpan);
        group.appendChild(label);

        var valuesWrap = document.createElement('div');
        valuesWrap.className = 'main-product__option-values';
        option.values.forEach(function (value) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'option-swatch' + (value === selectedOptions[position] ? ' is-selected' : '');
          btn.textContent = value;
          btn.addEventListener('click', function () {
            selectedOptions[position] = value;
            updateSelection(dialog);
          });
          valuesWrap.appendChild(btn);
        });
        group.appendChild(valuesWrap);
        variantsWrap.appendChild(group);
      });
    }

    var addBtn = dialog.querySelector('[data-quick-view-add]');
    addBtn.addEventListener('click', function () {
      var variant = findVariant(selectedOptions);
      if (!variant || !variant.available) return;
      var qtyInput = dialog.querySelector('[data-quick-view-qty]');
      var qty = parseInt(qtyInput.value, 10) || 1;

      addBtn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: qty })
      })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('cart:open'));
          close();
        })
        .catch(function () {})
        .finally(function () { addBtn.classList.remove('is-loading'); });
    });

    root.innerHTML = '';
    root.appendChild(dialog);
    updatePrice(dialog, initialVariant);
    // Ratings rely on the reviews metafield, which isn't exposed by the
    // /products/{handle}.js endpoint — drop the placeholder rather than show nothing.
    var ratingWrap = dialog.querySelector('[data-quick-view-rating]');
    if (ratingWrap) ratingWrap.remove();

    dialog.querySelector('[data-quick-view-close]').addEventListener('click', close);
    root.addEventListener('click', function (e) { if (e.target === root) close(); }, { once: true });

    open();
  }

  function updatePrice(dialog, variant) {
    var priceWrap = dialog.querySelector('[data-quick-view-price]');
    var onSale = variant.compare_at_price > variant.price;
    priceWrap.innerHTML =
      '<span class="price' + (onSale ? ' price--sale' : '') + '">' +
      (onSale
        ? '<span class="price__sale">' + formatMoney(variant.price) + '</span><span class="price__compare">' + formatMoney(variant.compare_at_price) + '</span>'
        : '<span class="price__regular">' + formatMoney(variant.price) + '</span>') +
      '</span>';
  }

  function updateSelection(dialog) {
    var variant = findVariant(selectedOptions);
    dialog.querySelectorAll('.main-product__option').forEach(function (group, position) {
      group.querySelectorAll('.option-swatch').forEach(function (btn) {
        btn.classList.toggle('is-selected', btn.textContent === selectedOptions[position]);
      });
      group.querySelector('span').textContent = selectedOptions[position];
    });

    var addBtn = dialog.querySelector('[data-quick-view-add]');
    var addLabel = dialog.querySelector('[data-quick-view-add-label]');
    if (variant) {
      updatePrice(dialog, variant);
      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? addLabel.dataset.available || 'Agregar al carrito' : 'Agotado';
    } else {
      addBtn.disabled = true;
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-view-open]');
    if (!trigger) return;
    e.preventDefault();
    var handle = trigger.dataset.productHandle;
    if (!handle) return;

    fetch('/products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(render)
      .catch(function () {});
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });
})();